import { render, staticRenderFns } from "./JobboardUser.vue?vue&type=template&id=49d923dc"
import script from "./JobboardUser.vue?vue&type=script&lang=js"
export * from "./JobboardUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports